import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useClients } from './context/ClientsProvider';
import ClientFilterStatus from './ClientsToolBar/ClientFilterStatus';
import ListToolBarActions from 'components/toolbar/ListToolBarActions';
import { useNeedPay } from 'modules/admin';
import SolarIcon from 'components/icons/SolarIcon';

interface ClientToolBarProps {
    setEditClientId: (clientId: number) => void;
}

const ClientToolBar = ({ setEditClientId }: ClientToolBarProps) => {
    const { t } = useTranslation(['Clients', 'common']);
    const { triggerListReset, triggerListRefresh, showEmail, showStatus, showCreated, toggleListColumn } = useClients();
    const { needPay } = useNeedPay();

    return (
        <div className="mb-3" style={{ minWidth: '100px' }}>
            <div className="page-toolbar-actions">
                <Button
                    className="fs-14"
                    size="sm"
                    variant="success"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        if (needPay()) return;
                        setEditClientId(0);
                    }}
                >
                    <SolarIcon name="plus" className="fs-14 p-0" />
                    <span className="ms-1">{t('toolAddClient')}</span>
                </Button>

                <ListToolBarActions
                    onReset={triggerListReset}
                    onRefresh={triggerListRefresh}
                    columns={{
                        items: [
                            { id: 'email', label: t('fields.email'), visible: showEmail },
                            { id: 'status', label: t('fields.status'), visible: showStatus },
                            { id: 'created', label: t('fields.created'), visible: showCreated },
                        ],
                        onToggle: (id) => toggleListColumn(id as 'email' | 'status' | 'created'),
                    }}
                />

                <ClientFilterStatus />
            </div>
        </div>
    );
};

export default ClientToolBar;
